require('!!raw-loader!/builds/874320/v2/src/index.html');